import * as React from 'react';
import { Page, Card } from 'tabler-react';
import Cookies from 'js-cookie';
import logo from '../../assets/brand_logo.svg';

import Request from '../../shared/request';

import PageComponent from '../PageComponent';

class AutoLogin extends PageComponent {
  state = {
    message: '正在自动登陆...',
  };

  async componentDidMount() {
    this.actionLogin();
  }

  async actionLogin() {
    let token;
    let forward;
    try {
      const search = new URLSearchParams(this.props.location.search);
      token = search.get('token');
      forward = search.get('forward');
    } catch (err) {
      // noop
    }
    if (token) {
      this.setState({ message: '正在检测账号信息...' });
      let userInfo;
      try {
        userInfo = JSON.parse(window.localStorage.getItem('login'));
      } catch (err) {
        // noop
      }
      if (userInfo && userInfo.displayName) {
        this.setState({
          message: `登陆中...`,
        });
        window.localStorage.setItem('login', null);
      }
      const domain = `.${window.location.host
        .split('.')
        .slice(-2)
        .join('.')}`;
      Cookies.set('malus-token', token, {
        domain,
        SameSite: 'lax',
      });
      const user = await Request.post(
        'getUserStatus',
        {},
        { 'x-malus-token': token },
      );
      if (user) {
        localStorage.setItem('login', JSON.stringify(user));
        window.location.href = forward || '/dashboard';
      } else {
        this.setState({ message: '自动登陆失败请点击 手动登陆' });
      }
    }
  }

  render() {
    return (
      <Page className="malus-login">
        <Card className="form-card login">
          <Card.Header>
            <a className="brand" href="/">
              <img src={logo} alt="" />
            </a>
            <span>自动登陆</span>
          </Card.Header>
          <Card.Body>
            {this.state.message}
            <div className="form-bottom">
              <a href="/dashboard/login" target="_self">
                手动登陆
              </a>
              <a href="/dashboard/forgot">忘记密码？</a>
            </div>
          </Card.Body>
        </Card>
      </Page>
    );
  }
}
export default AutoLogin;
